@if ($teacherData()) {
    <div class="w-full flex flex-col gap-y-1.5 p-4">
        @if (!$hideName()) {
            <h1 class="text-4xl font-bold">{{$teacherData()!.fullname}}</h1>
        }
        <div class="grid gap-y-1 gap-x-4 text-base my-4">
            @if ($teacherData()!.email) {
                <span class="grid grid-cols-5 gap-x-1">
                    <span class="font-bold text-primary shrink-0">Email:</span>
                    <a class="hover:underline text-primary cursor-pointer col-span-4" 
                        [href]="'mailto:'+$teacherData()!.email" target="_blank">{{$teacherData()!.email}}</a>
                </span>
            }
            @for (detail of $teacherData()?.details; track $index) {
                <span class="grid grid-cols-5 gap-x-1">
                    <span class="font-bold text-primary shrink-0">{{detail.label | translate}}:</span>
                    @switch(detail.type){
                        @case ('email') {
                            <a class="hover:underline text-primary cursor-pointer col-span-4" 
                                [href]="'mailto:' + detail.value" target="_blank">{{detail.value}}</a>
                        }
                        @case ('link') {
                            <a class="hover:underline text-primary cursor-pointer col-span-4" 
                                [href]="detail.value" target="_blank">{{detail.value}}</a>
                        }
                        @default {
                            <span [innerHTML]="detail.value" class="col-span-4"></span>
                        }
                    }
                </span>
            }
            @if ($teacherData()?.profiles?.length) {
                <span class="grid grid-cols-5 gap-x-1">
                    <span class="font-bold text-primary shrink-0">{{"Profiles" | translate}}:</span>
                    <div class="col-span-4">
                        @for (profile of $teacherData()?.profiles; track $index) {
                            <span class="flex gap-x-1">
                                <span class="font-bold text-primary shrink-0">{{profile.label | translate}}:</span>
                                <a class="hover:underline text-primary cursor-pointer" 
                                    [href]="profile.link" target="_blank">{{profile.link}}</a>
                            </span>
                        }
                    </div>
                </span>
            }
        </div>
        <h2 class="text-2xl font-bold">{{'Courses' | translate}}</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 3xl:grid-cols-4 gap-x-7 gap-y-7 ng-tns-c3607186-2">
            @for (course of $teacherTitularCourses(); track $index) {
                <meta-course-preview [course]="course" [title]="course.title" 
                    [lowerHeight]="coursesPreviewConfig.lowerHeight ?? false"
                    [showProgress]="coursesPreviewConfig.showProgress ?? false"
                    [showStudents]="coursesPreviewConfig.showStudents ?? false"
                    [showSkills]="coursesPreviewConfig.showSkills ?? false"
                    [showImage]="coursesPreviewConfig.showImage ?? false"
                    [showDescription]="coursesPreviewConfig.showDescription ?? false"
                    [showContentTypeIcon]="coursesPreviewConfig.showContentTypeIcon ?? false"
                    [showStarIcon]="(coursesPreviewConfig.showStarIcon ?? false) && (course.associatedToUser || false)"
                    [showLockIcon]="!!course.toBuy && !course.associatedToUser"
                    (doClick)="$courseToPreview.set(course)" class="cursor-pointer" />
            }
        </div>
    </div>
} @else {
    <div class="w-full flex flex-col gap-y-1.5 p-4">{{'Teacher details not found' | translate}}</div>
}

@defer (when $courseToPreview()) {
    @if ($courseToPreview()) {
        <meta-modal class="courseDetails"
            (doClose)="$courseToPreview.set(undefined)" [settings]="{contentWide: true, closable: true, closeOnEscape: true}">
            <meta-course-detail modal-content [course]="$courseToPreview()!" [needActivation]="!$courseToPreview()!.status" 
                (openCourse)="startCourse($courseToPreview()!, $event)" (updateData)="updateCourseToPreview($event)" />
        </meta-modal>
    }
}